import React from 'react'
import './customPopover.css';

export const CustomPopoverOption = ({ option }) => {
    return (
        <button
            className={`btn popover-opt d-block w-100 ${option.icon && ('text-start')}`}
            onClick={option.onClick}
            disabled={option.disabled}
        >

            {
                option.icon ?
                    <img
                        src={require(`../../assets/icons/${option.icon}`)}
                        alt="icon"
                        className="pe-1"
                    />
                    :
                    null
            }
            <span style={{ color: 'var(--gray-950)' }}>
                {option.name}
            </span>
        </button>
    )
}
